import React, { useRef, useState } from 'react';

export default function VoiceQuoteLink({ url }) {
  const [copiedUrl, setCopiedUrl] = useState('');
  const [fallback, setFallback] = useState(false);
  const input = useRef(null);
  async function copy() {
    try {
      await navigator.clipboard.writeText(url);
      setCopiedUrl(url);
      setFallback(false);
    } catch {
      setCopiedUrl('');
      setFallback(true);
    }
  }
  return <div className="voice-quote-link">
    <button type="button" className="voice-secondary-button" disabled={!url} onClick={copy}>この見積のURLをコピー</button>
    <span role="status">{copiedUrl && copiedUrl === url ? 'URLをコピーしました。' : ''}</span>
    {fallback && url && <label>見積共有URL（選択してコピー）<input ref={input} readOnly value={url} onFocus={event => event.target.select()} /></label>}
  </div>;
}
